<template>
  <!-- 担当課・局選択 -->
  <modal
    name="departmentcharge"
    :draggable="true"
    :resizable="true"
    :scrollable="true"
    :click-to-close="false"
    :min-width="600"
    :min-height="534"
    :max-width="800"
    width="600px"
    height="534px"
  >
    <div class="modal-header modalDialog-header">
      <div style="margin-left: 5px; padding-top: 3px">担当課・局選択</div>
      <button
        type="button"
        class="btn-close"
        style="margin-right: 3px; padding-top: 6px"
        @click="closeModal"
      ></button>
    </div>
    <div class="modal-body">
      <div class="heightscroll" style="padding: 0 15px 0 15px">
        <div v-if="radiochoice">
          <div class="d-flex">
            <div class="flex-tp">
              <div v-for="(item, index) in List" :key="index">
                <div class="mtp-1 mb-1 d-flex">
                  <label
                    class="form-check-label mx-2"
                    :for="item.defaultCheck2"
                  >
                    {{ item.title }}
                  </label>
                </div>
                <div
                  v-for="(item1, index1) in item.content"
                  :key="index1"
                  class="mtp-1 ms-2 d-flex"
                >
                  &emsp;<input
                    :id="item1.defaultCheck3"
                    v-model="item1.isTrue"
                    class="form-check-input"
                    type="radio"
                    name="radio"
                  />
                  <label
                    class="form-check-label mx-2"
                    :for="item1.defaultCheck3"
                  >
                    {{ item1.name }}
                  </label>
                </div>
              </div>
            </div>
            <div class="flex-tp">
              <div v-for="(items, indexs) in Lists" :key="indexs">
                <div class="mtp-1 mbm-1 d-flex">
                  <label
                    class="form-check-label mx-2"
                    :for="items.defaultCheck4"
                  >
                    {{ items.title }}
                  </label>
                </div>
                <div
                  v-for="(items1, indexs1) in items.content"
                  :key="indexs1"
                  class="mtp-1 ms-2 d-flex"
                >
                  &emsp;<input
                    :id="items1.defaultCheck5"
                    v-model="items1.isTrue"
                    class="form-check-input"
                    type="radio"
                    name="radio"
                  />
                  <label
                    class="form-check-label mx-2"
                    :for="items1.defaultCheck5"
                  >
                    {{ items1.name }}
                  </label>
                </div>
              </div>
            </div>
            <div class="flex-tp">
              <div v-for="(itemes, indexes) in Listes" :key="indexes">
                <div class="mtp-1 mbm-1 d-flex">
                  <label
                    class="form-check-label mx-2"
                    :for="itemes.defaultCheck6"
                  >
                    {{ itemes.title }}
                  </label>
                </div>
                <div
                  v-for="(itemes1, indexes1) in itemes.content"
                  :key="indexes1"
                  class="mtp-1 ms-2 d-flex"
                >
                  &emsp;<input
                    :id="itemes1.defaultCheck7"
                    v-model="itemes1.isTrue"
                    class="form-check-input"
                    type="radio"
                    name="radio"
                  />
                  <label
                    class="form-check-label mx-2"
                    :for="itemes1.defaultCheck7"
                  >
                    {{ itemes1.name }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div>
            <div class="d-flex mtp-3">
              <input
                id="defaultCheck1"
                v-model="checkall"
                class="form-check-input"
                type="checkbox"
                @click="checkAll"
              />
              <label
                class="form-check-label"
                style="margin-left: 7px"
                for="defaultCheck1"
              >
                全選択／解除
              </label>
            </div>
          </div>
          <div class="d-flex">
            <div class="flex-tp">
              <div v-for="(item, index) in List" :key="index">
                <div class="mtp-1 mb-1 d-flex">
                  <input
                    :id="item.defaultCheck2"
                    v-model="item.isTrue"
                    class="form-check-input"
                    style="margin-left: 21px"
                    type="checkbox"
                    @click="checkPart(item)"
                  />
                  <label
                    class="form-check-label"
                    style="margin-left: 7px"
                    :for="item.defaultCheck2"
                  >
                    {{ item.title }}
                  </label>
                </div>
                <div
                  v-for="(item1, index1) in item.content"
                  :key="index1"
                  class="mtp-1 d-flex"
                >
                  <input
                    :id="item1.defaultCheck3"
                    v-model="item1.isTrue"
                    class="form-check-input"
                    style="margin-left: 42px"
                    type="checkbox"
                  />
                  <label
                    class="form-check-label"
                    style="margin-left: 7px"
                    :for="item1.defaultCheck3"
                  >
                    {{ item1.name }}
                  </label>
                </div>
              </div>
            </div>
            <div class="flex-tp">
              <div v-for="(items, indexs) in Lists" :key="indexs">
                <div class="mtp-1 mbm-1 d-flex">
                  <input
                    :id="items.defaultCheck4"
                    v-model="items.isTrue"
                    class="form-check-input"
                    style="margin-left: 21px"
                    type="checkbox"
                    @click="checkParts(items)"
                  />
                  <label
                    class="form-check-label"
                    style="margin-left: 7px"
                    :for="items.defaultCheck4"
                  >
                    {{ items.title }}
                  </label>
                </div>
                <div
                  v-for="(items1, indexs1) in items.content"
                  :key="indexs1"
                  class="mtp-1 d-flex"
                >
                  <input
                    :id="items1.defaultCheck5"
                    v-model="items1.isTrue"
                    class="form-check-input"
                    style="margin-left: 42px"
                    type="checkbox"
                  />
                  <label
                    class="form-check-label"
                    style="margin-left: 7px"
                    :for="items1.defaultCheck5"
                  >
                    {{ items1.name }}
                  </label>
                </div>
              </div>
            </div>
            <div class="flex-tp">
              <div v-for="(itemes, indexes) in Listes" :key="indexes">
                <div class="mtp-1 mbm-1 d-flex">
                  <input
                    :id="itemes.defaultCheck6"
                    v-model="itemes.isTrue"
                    class="form-check-input"
                    style="margin-left: 21px"
                    type="checkbox"
                    @click="checkPartes(itemes)"
                  />
                  <label
                    class="form-check-label"
                    style="margin-left: 7px"
                    :for="itemes.defaultCheck6"
                  >
                    {{ itemes.title }}
                  </label>
                </div>
                <div
                  v-for="(itemes1, indexes1) in itemes.content"
                  :key="indexes1"
                  class="mtp-1 d-flex"
                >
                  <input
                    :id="itemes1.defaultCheck7"
                    v-model="itemes1.isTrue"
                    class="form-check-input"
                    style="margin-left: 42px"
                    type="checkbox"
                  />
                  <label
                    class="form-check-label"
                    style="margin-left: 7px"
                    :for="itemes1.defaultCheck7"
                  >
                    {{ itemes1.name }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center mbm-3 mtp-3">
          <ButtonMain button-name="設定" @click="set"></ButtonMain>
          <ButtonNormal
            class="ms-4"
            button-name="キャンセル"
            @click="cancel"
          ></ButtonNormal>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
export default {
  name: 'DepartmentCharge',
  props: {
    radiochoice: Boolean,
    center: Boolean
  },
  data() {
    return {
      checkall: false,
      List: [
        {
          defaultCheck2: '1',
          isTrue: false,
          title: '本省',
          content: [
            {
              defaultCheck3: '12',
              isTrue: false,
              name: '訟務企画課本省'
            },
            {
              defaultCheck3: '13',
              isTrue: false,
              name: '民事訟務課本省'
            },
            {
              defaultCheck3: '14',
              isTrue: false,
              name: '行政訟務課本省'
            },
            {
              defaultCheck3: '15',
              isTrue: false,
              name: '租税訟務課本省'
            },
            {
              defaultCheck3: '16',
              isTrue: false,
              name: '訟務支援課本省'
            }
          ]
        },
        {
          defaultCheck2: '2',
          isTrue: false,
          title: '東京管区',
          content: [
            {
              defaultCheck3: '17',
              isTrue: false,
              name: '東京法務局'
            },
            {
              defaultCheck3: '18',
              isTrue: false,
              name: '横浜地方法務局'
            },
            {
              defaultCheck3: '19',
              isTrue: false,
              name: 'さいたま地方法務局'
            },
            {
              defaultCheck3: '20',
              isTrue: false,
              name: '千葉地方法務局'
            },
            {
              defaultCheck3: '21',
              isTrue: false,
              name: '水戸地方法務局'
            },
            {
              defaultCheck3: '22',
              isTrue: false,
              name: '宇都宮地方法務局'
            },
            {
              defaultCheck3: '23',
              isTrue: false,
              name: '前橋地方法務局'
            },
            {
              defaultCheck3: '24',
              isTrue: false,
              name: '静岡地方法務局'
            },
            {
              defaultCheck3: '25',
              isTrue: false,
              name: '甲府地方法務局'
            },
            {
              defaultCheck3: '26',
              isTrue: false,
              name: '長野地方法務局'
            },
            {
              defaultCheck3: '27',
              isTrue: false,
              name: '新潟地方法務局'
            }
          ]
        },
        {
          defaultCheck2: '3',
          isTrue: false,
          title: '大阪管区',
          content: [
            {
              defaultCheck3: '28',
              isTrue: false,
              name: '大阪法務局'
            },
            {
              defaultCheck3: '29',
              isTrue: false,
              name: '京都地方法務局'
            },
            {
              defaultCheck3: '30',
              isTrue: false,
              name: '神戸地方法務局'
            },
            {
              defaultCheck3: '31',
              isTrue: false,
              name: '奈良地方法務局'
            },
            {
              defaultCheck3: '32',
              isTrue: false,
              name: '大津地方法務局'
            },
            {
              defaultCheck3: '33',
              isTrue: false,
              name: '和歌山地方法務局'
            }
          ]
        }
      ],
      Lists: [
        {
          defaultCheck4: '4',
          isTrue: false,
          title: '名古屋管区',
          content: [
            {
              defaultCheck5: '34',
              isTrue: false,
              name: '名古屋法務局'
            },
            {
              defaultCheck5: '35',
              isTrue: false,
              name: '津地方法務局'
            },
            {
              defaultCheck5: '36',
              isTrue: false,
              name: '岐阜地方法務局'
            },
            {
              defaultCheck5: '37',
              isTrue: false,
              name: '福井地方法務局'
            },
            {
              defaultCheck5: '38',
              isTrue: false,
              name: '金沢地方法務局'
            },
            {
              defaultCheck5: '39',
              isTrue: false,
              name: '富山地方法務局'
            }
          ]
        },
        {
          defaultCheck4: '5',
          isTrue: false,
          title: '広島管区',
          content: [
            {
              defaultCheck5: '40',
              isTrue: false,
              name: '広島法務局'
            },
            {
              defaultCheck5: '41',
              isTrue: false,
              name: '山口地方法務局'
            },
            {
              defaultCheck5: '42',
              isTrue: false,
              name: '岡山地方法務局'
            },
            {
              defaultCheck5: '43',
              isTrue: false,
              name: '鳥取地方法務局'
            },
            {
              defaultCheck5: '44',
              isTrue: false,
              name: '松江地方法務局'
            }
          ]
        },
        {
          defaultCheck4: '6',
          isTrue: false,
          title: '福岡管区',
          content: [
            {
              defaultCheck5: '45',
              isTrue: false,
              name: '福岡法務局'
            },
            {
              defaultCheck5: '46',
              isTrue: false,
              name: '佐賀地方法務局'
            },
            {
              defaultCheck5: '47',
              isTrue: false,
              name: '長崎地方法務局'
            },
            {
              defaultCheck5: '48',
              isTrue: false,
              name: '大分地方法務局'
            },
            {
              defaultCheck5: '49',
              isTrue: false,
              name: '熊本地方法務局'
            },
            {
              defaultCheck5: '50',
              isTrue: false,
              name: '鹿児島地方法務局'
            },
            {
              defaultCheck5: '51',
              isTrue: false,
              name: '宮崎地方法務局'
            },
            {
              defaultCheck5: '52',
              isTrue: false,
              name: '那覇地方法務局'
            }
          ]
        }
      ],
      Listes: [
        {
          defaultCheck6: '7',
          isTrue: false,
          title: '仙台管区',
          content: [
            {
              defaultCheck7: '53',
              isTrue: false,
              name: '仙台法務局'
            },
            {
              defaultCheck7: '54',
              isTrue: false,
              name: '福島地方法務局'
            },
            {
              defaultCheck7: '55',
              isTrue: false,
              name: '山形地方法務局'
            },
            {
              defaultCheck7: '56',
              isTrue: false,
              name: '盛岡地方法務局'
            },
            {
              defaultCheck7: '57',
              isTrue: false,
              name: '秋田地方法務局'
            },
            {
              defaultCheck7: '58',
              isTrue: false,
              name: '青森地方法務局'
            }
          ]
        },
        {
          defaultCheck6: '8',
          isTrue: false,
          title: '札幌管区',
          content: [
            {
              defaultCheck7: '59',
              isTrue: false,
              name: '札幌法務局'
            },
            {
              defaultCheck7: '50',
              isTrue: false,
              name: '函館地方法務局'
            },
            {
              defaultCheck7: '61',
              isTrue: false,
              name: '旭川地方法務局'
            },
            {
              defaultCheck7: '62',
              isTrue: false,
              name: '釧路地方法務局'
            }
          ]
        },
        {
          defaultCheck6: '9',
          isTrue: false,
          title: '高松管区',
          content: [
            {
              defaultCheck7: '63',
              isTrue: false,
              name: '高松法務局'
            },
            {
              defaultCheck7: '64',
              isTrue: false,
              name: '徳島地方法務局'
            },
            {
              defaultCheck7: '65',
              isTrue: false,
              name: '高知地方法務局'
            },
            {
              defaultCheck7: '66',
              isTrue: false,
              name: '松山地方法務局'
            }
          ]
        }
      ],
      windowHeight: ''
    }
  },
  mounted() {
    this.windowHeight = window.innerHeight
    window.addEventListener('resize', this.innerHeight)
  },
  destroyed() {
    window.removeEventListener('resize')
  },
  methods: {
    innerHeight() {
      var height = window.innerHeight
      this.windowHeight = height
    },
    checkAll() {
      if (this.checkall === false) {
        this.List.forEach(item => {
          item.isTrue = true
          item.content.forEach(item1 => {
            item1.isTrue = true
          })
        })
      } else {
        this.List.forEach(item => {
          item.isTrue = false
          item.content.forEach(item1 => {
            item1.isTrue = false
          })
        })
      }
      if (this.checkall === false) {
        this.Lists.forEach(item => {
          item.isTrue = true
          item.content.forEach(item1 => {
            item1.isTrue = true
          })
        })
      } else {
        this.Lists.forEach(item => {
          item.isTrue = false
          item.content.forEach(item1 => {
            item1.isTrue = false
          })
        })
      }
      if (this.checkall === false) {
        this.Listes.forEach(item => {
          item.isTrue = true
          item.content.forEach(item1 => {
            item1.isTrue = true
          })
        })
      } else {
        this.Listes.forEach(item => {
          item.isTrue = false
          item.content.forEach(item1 => {
            item1.isTrue = false
          })
        })
      }
    },
    checkPart(item) {
      if (item.isTrue === false) {
        item.content.forEach(items => {
          items.isTrue = true
        })
      } else {
        item.content.forEach(items => {
          items.isTrue = false
          this.checkall = false
        })
      }
    },
    checkParts(items) {
      if (items.isTrue === false) {
        items.content.forEach(items => {
          items.isTrue = true
        })
      } else {
        items.content.forEach(items => {
          items.isTrue = false
          this.checkall = false
        })
      }
    },
    checkPartes(itemes) {
      if (itemes.isTrue === false) {
        itemes.content.forEach(items => {
          items.isTrue = true
        })
      } else {
        itemes.content.forEach(items => {
          items.isTrue = false
          this.checkall = false
        })
      }
    },
    cancel() {
      this.$emit('close')
    },
    set() {
      this.$emit('close')
    },
    closeModal() {
      this.$emit('close')
    }
  }
}
</script>
<style scoped lang="scss">
.modalDialog-header {
  background: rgb(229, 235, 250);
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: 5px 10px;
  border-radius: 5px 5px 0 0;
  z-index: 1100 !important;
}

.heightscroll {
  height: 500px;
  overflow-y: auto;
}
.flex-tp > div {
  margin-top: 20px;
}
.flex-tp > div:nth-of-type(1) {
  margin-top: 0;
}
</style>
